// FILE: src/constant.js
// What a student needs to take the course (MTO 12.1.1: hardware, browser,
// software and connection). The one source for the public System
// requirements page; edit the words here.
const systemRequirements = [
  {
    title: "Device",
    items: [
      "A computer (Windows, Mac or Chromebook) or a tablet. A larger screen makes lessons easier to follow.",
      "Phones work for your dashboard, profile and support. For lessons, use a computer or tablet if you can.",
      "Screen at least 1280 × 720 on a computer",
      "Speakers or headphones: lessons have narration and video (captions are available)"
    ]
  },
  {
    title: "Browser",
    items: [
      "Google Chrome, Microsoft Edge, Mozilla Firefox or Apple Safari, one of the two latest versions",
      "JavaScript and cookies turned on",
      "Browser zoom, screen readers and high-contrast settings are supported"
    ]
  },
  {
    title: "Internet",
    items: [
      "Broadband of at least 5 Mbps download and 1 Mbps upload",
      "10 Mbps or faster is recommended for video",
      "A stable connection: if it drops, your progress is saved and you continue where you left off"
    ]
  },
  {
    title: "Email",
    items: [
      "An email address you can check while signing in: every sign-in needs a one-time code we email you",
      "Mark our emails as safe (not spam) so your codes arrive quickly"
    ]
  }
];

export default systemRequirements;
